/** The keys the two ends of every tree are made with: where a job begins, and Project Complete, its special last step. */
export const BUILDER_START = 'project.setup';
export const BUILDER_END = 'project.archive';
